import { Flex, Group, Pill, Stack, Text } from '@mantine/core';

import { PatentValidationAction } from '@/module/Author/Patent/Validation/PatentValidationAction';
import { PatentValidationHistory } from '@/module/Author/Patent/Validation/PatentValidationHistory';
import { PatentDeleteButton } from '@/module/Author/Patent/components/PatentDeleteButton';

import { Content, EditButtonLink } from '@/core/components';

import { AuthorList } from '@feature/utils';

import { Patent } from './model/PatentTypes';

interface PatentViewProps {
  patent: Patent;
}

export function PatentView(props: PatentViewProps) {
  const { patent } = props;
  const {
    title,
    registrationNo,
    state,
    type,
    institutions,
    authors,
    submissionYear,
    grantingYear,
    owner,
    universityAffiliatedNoOfAuthors,
  } = patent;

  return (
    <Stack>
      <Content type="full">
        <Stack gap="4px">
          <Flex justify="space-between">
            <Group>
              <Text fw="500">{title}</Text>
              <Pill>{state?.name}</Pill>
            </Group>
            <Group>
              <EditButtonLink
                size="xs"
                miw="100px"
              />
              <PatentDeleteButton patentId={patent.id} />
            </Group>
          </Flex>
          <Text
            c="dimmed"
            size="sm"
          >
            {owner?.name}, {type?.name}, {registrationNo}
          </Text>
          <Text
            c="dimmed"
            size="sm"
          >
            Depus {submissionYear}, Câștigat: {grantingYear ?? '-'}
          </Text>
          <Group>
            {(institutions ?? []).map(inst => (
              <Pill key={inst.id}>{inst.name}</Pill>
            ))}
          </Group>
        </Stack>
      </Content>
      <Content type="full">
        <AuthorList
          authors={authors}
          affiliatedNo={universityAffiliatedNoOfAuthors}
        />
      </Content>
      <PatentValidationAction patentId={patent.id} />
      <PatentValidationHistory patentId={patent.id} />
    </Stack>
  );
}
